import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import React, { useState, useRef } from 'react'
import { useHistory } from 'react-router-dom';
import api from '../../service/AxiosInstance';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'prismjs/themes/prism-coy.css';
import '../../assets/demo/flags/flags.css';
import '../../assets/demo/Demos.scss';
import '../../assets/layout/layout.scss';
import './Login.css';
import { Toast } from 'primereact/toast';
import { Image } from 'primereact/image';
import { Password } from 'primereact/password';



const Login = () => {

    const [checked, setChecked] = useState(false);
    const [newPwd, setNewPwd] = useState(null);
    const toast = useRef(null);
    const user_connect_local = localStorage.getItem("user_connect");
    const user_connect = JSON.parse(user_connect_local);
    // const message = useRef(null);
    const [user, setUser] = useState({
        pwd_portail: '',
        numcont: '',


    });

    // const [isAuthenticated, setAuth] = useState(localStorage.getItem("auth"));
    const [isAuthenticated, setAuth] = useState(false);

    const navigate = useHistory();


    const handleChange = (event) => {
        setUser({
            ...user,
            [event.target.name]: event.target.value
        });
    }


    const changePassword = (e) => {

        e.preventDefault();
        if (newPwd !== user.pwd_portail) {
            toast.current.show({
                severity: 'error',
                summary: 'Changement Mot de Passe',
                detail: 'Les mots de passe saisis ne correspondent pas !',
                life: 5000,
                style: { with: '100px' }
            });
        } else {

            user.numcont = `${user_connect.numcont}`;

            api.put("User/portail/updatePwd", user,
                {
                    Headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(user)
                }).then(res => {
                    toast.current.show({
                        severity: 'info',
                        summary: 'Changement Mot de Passe',
                        detail: 'Le mot de passe est correctement modifié !',
                        life: 5000,
                        style: { with: '100px' }
                    });
                })


        }

    }


    return (
        <>
            <Toast ref={toast} />


            <div >
                <Toast ref={toast} />
                <div className="surface-card p-4 shadow-2 border-round w-full lg:w-6">
                    <div className="text-center mb-5">
                        <Image preview src={`images/photos/${user_connect.matipm}.jpg`} alt="Ma Photo" width="150" height="150" className="mb-3" />
                        <div className="text-900 text-3xl font-medium mb-3">{`   ${user_connect.prenom} ${user_connect.nom}`}</div>
                        <span className="text-600 font-medium line-height-3">{`   ${user_connect.email} / ${user_connect.portable} `}</span>
                        {/* <a className="font-medium no-underline ml-2 text-blue-500 cursor-pointer">Create today!</a> */}
                    </div>

                    <div>
                        <label htmlFor="new_pwd" className="block text-900 font-medium mb-2">Nouveau Mot de Passe</label>
                        <Password value={newPwd} onChange={(e) => setNewPwd(e.target.value)} className="w-full mb-3"
                            id='new_pwd'
                            promptLabel='Min. 8 Caractères (Majuscule/Miniscule/Chiffre/Caractères Spéciaux)'
                            weakLabel='Faible'
                            mediumLabel='Moyen'
                            strongLabel='Fort' />

                        <label htmlFor="pwd_portail" className="block text-900 font-medium mb-2 mt-4">Confirmer Mot de Passe</label>
                        <InputText type="password" required="" id="pwd_portail" name='pwd_portail' value={user.pwd_portail} onChange={handleChange} className="w-full mb-3" />

                        <Button label="Enregistrer" icon="pi pi-save" className="w-full" onClick={changePassword} disabled={!newPwd || newPwd.length < 8} />
                    </div>
                </div>
            </div>
        </>


    );
}



export default Login;
